import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["id"];
import { watch, nextTick, onUnmounted } from 'vue';
import * as echarts from 'echarts';
export default {
  __name: 'lineAnalysis',
  props: {
    id: {
      type: String,
      default: 'echart'
    },
    data: {
      type: Object,
      default: function _default() {}
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var series = [{
      name: '',
      type: 'line',
      yAxisIndex: 0,
      smooth: true,
      areaStyle: {
        color: '#E0FDEF'
      },
      itemStyle: {
        color: '#56C08D'
      },
      showSymbol: false,
      data: []
    }, {
      name: '',
      type: 'line',
      yAxisIndex: 0,
      smooth: true,
      areaStyle: {
        color: '#D6E2FF'
      },
      itemStyle: {
        color: '#366EF4'
      },
      showSymbol: false,
      data: []
    }];
    var timer = null;
    var echartData = function echartData(data) {
      // let myChart = echarts.init(document.getElementById(props.id))
      var dom = document.getElementById(props.id);
      if (!dom) return;
      var myChart = echarts.init(dom);
      window.addEventListener('resize', function () {
        console.log(1111);
        myChart.resize();
      });
      var newSeries = data.series.map(function (item, index) {
        return _objectSpread(_objectSpread({}, series[index]), {}, {
          name: item.name,
          data: item.data.map(function (item) {
            return item;
          })
        });
      });
      var option = {
        title: {
          text: data.title,
          left: 'left',
          show: data.showTitle
        },
        tooltip: {
          trigger: 'axis'
        },
        yAxis: [{
          type: 'value',
          name: '',
          position: 'left'
        }],
        legend: {
          top: 0,
          right: 0,
          data: data.legend
        },
        xAxis: {
          type: 'category',
          data: data.xaxis
        },
        series: newSeries
        /*dataZoom: [
          {
            type: 'slider',
            start: 0,
            end: 100,
            maxValueSpan: 31,
          },
        ],*/
      };
      if (data.isRate) {
        option.yAxis = [{
          type: 'value',
          name: '',
          position: 'left',
          max: 100,
          axisLabel: {
            formatter: '{value}%'
          }
        }];
      } else {
        option.yAxis = [{
          type: 'value',
          name: '',
          position: 'left',
          max: null,
          axisLabel: {
            formatter: '{value}'
          }
        }];
      }
      option && myChart.setOption(option);
      timer = setTimeout(function () {
        myChart.resize();
      }, 100);
    };
    watch(function () {
      // console.log(props.data,84)
      if (props.data && Object.keys(props.data).length > 0) {
        nextTick(function () {
          echartData(props.data);
        });
      }
    });
    onUnmounted(function () {
      if (timer) {
        clearTimeout(timer);
      }
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        id: __props.id,
        style: {
          "width": "100%",
          "height": "300px"
        }
      }, null, 8, _hoisted_1);
    };
  }
};